import $ from 'jquery';
import newsletterForm from './newsletterForm'

let body;

export default {
	init: function() {
		body = $('body');
        body.on('click','[data-modal-close]',function(e) {
            e.preventDefault();
            var m = $(this).closest('.modal');
            if(!m.hasClass('close')) {
                m.addClass('close');
                body.removeClass('modal-show no-scroll');
                setTimeout( () => {
                    
                    m.remove();
                }, 600);
            }
        });
        body.on('click','a[href="#newsletter"],a[href="#modal-newsletter"]',function(e) {
            e.preventDefault();
            var html = $('#newsletter-modal-html').html();
            if(!html) return;
            body.append( html );
            body.find('.modal').last().trigger('strutforms-init');
            var form = body.find('.modal .strutform');
            newsletterForm.init();
            setTimeout( () => {
                body.addClass('modal-show no-scroll');
            }, 50 );
        });

        
	},

    alert: function( html, button, cb ) {
        var m = $("<div class='modal'><div class='modal__wrap'><div class='modal__inner'><div class='modal__window'></div></div></div></div>").appendTo($('body'));
        var w = m.find('.modal__window');
        w.html("<a class='modal__window__close' data-modal-close><i class='icon-close'></i></a>");
        w.append(html);
        if(button) {
            w.append("<p><button type='button' class='button' data-modal-close>" + button + "</button></p>");
            if(cb) {
                m.find('button').on('click',function() {
                    cb();
                });
            }
        }
        $('body').addClass('modal-show no-scroll');
    }
}
